import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

import SlideUpDownNav from './../inc/SlideUpDownNav';

import SwiperCore, { Navigation, Autoplay, A11y, EffectFade } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

class Quote extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let _this = this;
        let { ml_published } = this.props;
        let data = [];
        if (ml_published) {
            ml_published.map((article, index) => {
                data.push({
                    publish_year: article.acf.publish_year,
                    published_by: article.acf.published_by,
                    author: article.acf.author,
                    company: article.acf.company,
                    image: article.acf.image,
                    title: article.title.rendered
                });
                
            })
        }
        data.sort(function(a, b) {
            var keyA = new Date(a.publish_year),
              keyB = new Date(b.publish_year);
            // Compare the 2 dates
            if (keyB < keyA) return -1;
            if (keyB > keyA) return 1;
            return 0;
          });
        return (
            <section className="section" id="published" data-logo="hide">
                <div className="mole__about--content-slides fullW">
                    <div className="main-container">
                        <div className="inner-container">
                            <h3 className="font-lg-head c-general mb-0">Published</h3>

                            <Swiper
                                className="swiper-eq-height mole__published-swiper"
                                touchRatio={false}
                                navigation={{
                                    prevEl: '#publish--swiper-hero--prev',
                                    nextEl: '#publish--swiper-hero--next',
                                }}
                                breakpoints={{
                                    960: {
                                        slidesPerView: 2,
                                        spaceBetween: 50
                                    },
                                    1100: {
                                        slidesPerView: 4,
                                        spaceBetween: 50
                                    },
                                    1300: {
                                        slidesPerView: 5,
                                        spaceBetween: 50
                                    }
                                }}
                            >
                                {
                                    (data).map((article, key) => {
                                        let year = article['publish_year'];
                                        return (
                                            <SwiperSlide key={key}>
                                                <div className="mole--published-contents">
                                                <h6 className="--grid-heading c-general">{year}</h6>
                                               
                                                <div>
                                                    <p dangerouslySetInnerHTML={{__html:article.title}}/>
                                                    {
                                                        article.published_by &&
                                                        <p>{article.published_by}</p>
                                                    }
                                                    {/* <a className="--grid-item-link" href="javascript:"></a> */}
                                                    <p>&nbsp;</p>
                                                </div>
                                               
                                                {
                                                    article.author &&
                                                    <p className="c-general">{article.author}</p>
                                                }
                                                {
                                                    article.company &&
                                                    <p className="c-general">{article.company}</p>
                                                }
                                                <p>&nbsp;</p>
                                                </div>
                                                {
                                                    article.image &&
                                                    <figure>
                                                        <img src={article.image.url}/>
                                                    </figure>
                                                }
                                                   
                                            </SwiperSlide>
                                        )
                                    })
                                }

                                {/* swiper arw */}
                                <div className="swiper-nav">
                                    <span className="swiper-hero--prev" id="publish--swiper-hero--prev">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                            <polygon points="4.7,34.1 5.2,34.6 5.2,34.6 15.8,45.3 30.5,60 35.7,54.8 21,40.1 10.3,29.5 20.4,19.3 34.6,5.2 29.5,0  15.3,14.2 5.2,24.3 5.2,24.3 4.8,24.6 0,29.5 0,29.5 " />
                                        </svg>
                                    </span>

                                    <span className="swiper-hero--next" id="publish--swiper-hero--next">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                            <polygon points="35.7,29.5 35.7,29.5 30.9,24.6 30.5,24.3 30.5,24.3 20.4,14.2 6.2,0 1.1,5.2 15.3,19.3 25.4,29.5 14.7,40.1 0,54.8 5.2,60 19.9,45.3 30.5,34.6 30.5,34.6 31,34.1 " />
                                        </svg>
                                    </span>
                                </div>

                            </Swiper>

                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Quote;



// WEBPACK FOOTER //
// ./src/components/About/Published.js